/* eslint-disable max-len */
const translation = {
  general: {
    errors: {
      required: 'Bitte füllen Sie alle erforderlichen Felder aus',
      emailError: 'Bitte geben Sie eine gültige E-Mail Adresse ein',
      generalError: 'Ein Fehler ist aufgetretten. Bitte versuchen Sie es erneut',
      error404: 'Nicht gefunden',
    },
  },
  notFound: {
    title: 'Ups! Die Seite, die Sie suchen, existiert nicht.',
    subtitle: 'Sie wurde vielleicht entfernt, umbenannt oder hat nie existiert.',
  },
  checkout: {
    checkoutErrors: {
      headline: 'Fehler',
    },
    steps: {
      chooseTicket: 'Tickets auswählen',
      enterAttendee: 'Teilnehmerdaten eingeben',
      invoiceAddress: 'Rechnungsadresse eingeben',
      summary: 'Zusammenfassung',
      review: 'Zusammenfassung',
    },
    invoiceAddress: {
      company: 'Firma',
      forename: 'Vorname',
      name: 'Name',
      address: 'Straße + Hausnummer',
      postalCode: 'Postleitzahl',
      city: 'Stadt',
      country: 'Land',
      emailAddress: 'E-Mail',
    },
    back: 'Zurück',
    next: 'Weiter',
    soldOut: 'Ausverkauft',
    submit: 'Kostenpflichtig bestellen',
    acceptTOS: `Ich bestätige, dass die Angaben, insbesondere Name und E-Mail-Adresse, von allfällig zusätzlichen Teilnehmenden korrekt sind.
        Dies ist wichtig, da die Tickets per E-Mail versendet werden. Des Weiteren akzeptiere ich die Teilnahmebedingungen der Seminar GmbH`,
    insufficientInventory: `Leider sind folgende Tickets nicht mehr oder nur in begrenzter Stückzahl verfügbar.
      Bitte passen Sie die Bestellmenge entsprechend an.`,
    insufficientInventoryAffectdCategories: 'Betroffene Kategorien',
    error: 'Fehler',
    paymentErrors: {
      headline: 'Zahlungsfehler',
      general: 'Bei der Zahlung ist ein Fehler aufgetreten. Bitte wählen Sie eine andere Zahlungsart.',
      insufficient_funds: 'Die Karte verfügt über unzureichende Deckung. Bitte verwenden Sie eine andere Kreditkarte.',
      lost_card: 'Diese Karte wurde als verloren gemeldet und ist gesperrt. Bitte verwenden Sie eine andere Kreditkarte.',
      stolen_card: 'Diese Karte wurde als gestohlen gemeldet und ist gesperrt. Bitte verwenden Sie eine andere Kreditkarte.',
      expired_card: 'Diese Karte ist abgelaufen. Bitte verwenden Sie eine andere Kreditkarte.',
      incorrect_cvc: 'Falscher Sicherheitscode (CVC). Bitte überprüfen Sie die Eingabe.',
    },
    coupon: {
      label: 'Rabattcode',
      placeholder: 'Code eingeben',
      apply: 'Anwenden',
      remove: 'Entfernen',
      applied: 'Rabatt',
      error: 'Rabattcode konnte nicht angewendet werden',
      errors: {
        ENOTFOUND: 'Der eingegebene Rabattcode wurde nicht gefunden.',
        ENOTVALIDANYMORE: 'Dieser Rabattcode ist nicht mehr gültig.',
        ELIMITREACHED: 'Dieser Rabattcode wurde bereits vollständig eingelöst.',
        EALREADYADDED: 'Dieser Rabattcode wurde bereits angewendet.',
        ENOTAPPLICABLE: 'Dieser Rabattcode kann auf die aktuelle Auswahl nicht angewendet werden.',
      },
    },
  },
  texts: {
    imprint: 'Impressum',
    privacyPolicy: 'Datenschutz',
    toc: 'AGB',
    rightOfWithdrawal: 'Widerrufsrecht',
  },
};

export default translation;
